import { log } from 'log';
import { useCallback } from 'react';

import * as Types from '../types';

export const useXpointRequestPacket = ({
    sdk,
    transactionID
}: {
    sdk: Types.XPointSDKInstance | null;
    transactionID: string | null;
}) => {
    return useCallback(async () => {
        if (!sdk) {
            return;
        }

        log('gcReq', {
            transactionID
        });
    }, [
        sdk,
        transactionID
    ]);
};
